import BarChartRepository from '@src/repositories/BarChartRepository';

class BarChartService {
  constructor() {
    this.barChartRepository = new BarChartRepository();
  }

  async createBarChart({ data, orgId, divId = null, boardId }) {
    return this.barChartRepository.create({ data, orgId, divId, boardId });
  }

  async updateBarChart({ data, orgId, divId = null, boardId, chartId }) {
    return this.barChartRepository.update({ data, orgId, divId, boardId, chartId });
  }

  async deleteBarChart({ orgId, divId = null, boardId, chartId }) {
    return this.barChartRepository.delete({ orgId, divId, boardId, chartId });
  }

  async getBarChart({ orgId, divId = null, boardId, chartId }) {
    return this.barChartRepository.get({ orgId, divId, boardId, chartId });
  }
}

export default BarChartService;
